<div class="file-dnd-container" fxLayout="column" fxLayoutGap="8px" appDnd (fileDropped)="onFilesSelect($event)">
  <div
    class="dropzone"
    fxLayout="column" fxFlex="100" fxLayoutGap="15px"
    (click)="openFileSelect()"
  >
    <input [accept]="acceptMime" type="file" hidden #fileDropRef id="fileDropRef" [multiple]="multiple" (change)="onFilesSelect($any($event.target).files)"/>
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center">
      <mat-icon>cloud_upload</mat-icon>
    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center">
      Upuść tutaj pliki lub kliknij aby przeglądać (max {{maxSize/1024/1024 | number:'1.0-2'}} MB)
    </div>
  </div>
  <ng-container *ngFor="let selectedFile of selectedFiles; let index = index">
    <ng-container *ngIf="!fileResults?.hasOwnProperty(index) || !fileResults[index].result === true">

      <div class="file" fxFill fxLayout="row" fxFlex="100" fxLayoutGap="15px" fxLayoutAlign="start center">
        <div fxFlex="4">
          <button mat-icon-button><mat-icon>description</mat-icon></button>
        </div>
        <div fxFlex="90">
          <div fxLayout="column">
            <div class="name" fxLayout="row" fxFlex="100" fxLayoutGap="5px">
              <div class="file-name">{{selectedFile.name}}</div>
              <span class="file-size">{{selectedFile.size/1024/1024 | number:'1.0-2'}} MB</span>
            </div>
            <div
              class="file-error"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="5px"
              *ngIf="fileResults?.[index]?.result === false && fileResults?.[index]?.errorText"
            >
              <mat-icon>error</mat-icon>  <span>  {{fileResults[index].errorText}} </span>
            </div>
          </div>
        </div>
        <div fxFlex="6" fxFill>
          <div *ngIf="!fileResults?.hasOwnProperty(index) || fileResults[index].result === false">
            <button mat-icon-button color="warn" (click)="unselectFile(index)"><mat-icon>delete</mat-icon></button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-container  *ngFor="let invoice of invoices; let index = index">
    <ng-container *ngIf="invoice && !disabledInvoice">
      <div class="file"  fxLayout="row" fxFlex="100" fxLayoutGap="15px" fxLayoutAlign="start center"  [ngClass]="invoice.status.key === INVOICE_STATUS_TO_BE_REALIZED ? 'invoice-realized' : ''">
        <div fxFlex="4" fxLayout="row">
          <button mat-icon-button><mat-icon>description</mat-icon></button>
        </div>
        <div fxFlex="50" fxLayout="row">
          <div class="name" fxLayout="column" fxFlex="100" *ngIf="hiddenIndex !== index">
            <div fxLayout="row" class="file-name">{{invoice.fileName}}</div>
            <div fxLayout="column" class="file-size">
              Partner: {{invoice?.partner?.fullName}} <br>
              Umowa: {{invoice?.contract?.type?.name}} (nr: {{invoice?.contract?.number}}), {{invoice?.contract?.status.name}} <br>
              <b>Kwota brutto: {{(invoice?.gross === null ? 0 : invoice?.gross) | number:'1.2-2'}} zł | Kwota netto: {{(invoice?.net === null ? 0 : invoice?.net) | number:'1.2-2'}} zł</b>
            </div>
          </div>
        </div>
        <div fxFlex="23" fxLayout="row">
          <ng-container  *ngIf="invoice.status.key === INVOICE_STATUS_TO_BE_CORRECTED" >
            <div class="name"  fxFlex="100" fxLayout="column" fxLayoutGap="0px" fxLayoutAlign="center center">
<!--              <button mat-button (click)="getInvoice(invoice.uuid, index)">-->
<!--                <mat-icon class="negative-icon">cancel</mat-icon> Do korekty-->
<!--              </button>-->
              <div class="file-size-block " *ngIf="invoice?.partner?.invoiceAddBlockPremium && invoice?.contract?.company?.key === COMPANY_ASF_PREMIUM">OFWCA posiada blokadę dodawania faktur ASF Premium</div>
              <div class="file-size-block" *ngIf="invoice?.partner?.invoiceAddBlockAsf && invoice?.contract?.company?.key === COMPANY_ASF">OFWCA posiada blokadę dodawania faktur ASF</div>
              <div class="file-size" *ngIf="invoice.partner === null || invoice.contract === null">Brak partnera / Umowy</div>
              <div class="file-size" *ngIf="invoice.net == 0 || invoice.net > invoice?.contractBalance?.toPayNet">Brak kwoty do wypłacenia</div>
              <div class="file-size" *ngIf="invoice.gross == 0">Brak kwoty faktury brutto</div>
              <div class="file-size" *ngIf="invoice.contractorCompanyName === null">Brak Firmy / Umowy</div>
              <div class="file-size" *ngIf="invoice.sellerAccountNumber === null">Brak nr rachunku bankowego</div>
              </div>
          </ng-container>
          <ng-container *ngIf="invoice.status.key === INVOICE_STATUS_TO_BE_REALIZED" >
            <div class="name"  fxFlex="100" fxLayout="column" fxLayoutGap="0px" fxLayoutAlign="center center">
              <button mat-button (click)="getInvoice(invoice.uuid, index)"><mat-icon class="positive-icon">check_circle</mat-icon> Poprawny</button>
            </div>
          </ng-container>
        </div>
        <div fxFlex="23" fxLayout="row"  fxLayoutAlign="space-evenly center">
          <div>
            <button mat-button (click)="getInvoice(invoice.uuid, index)">
              <ng-container *ngIf="invoice.status.key === INVOICE_STATUS_TO_BE_CORRECTED">
                <mat-icon class="negative-icon">cancel</mat-icon>
              </ng-container>
              <ng-container *ngIf="invoice.status.key === INVOICE_STATUS_TO_BE_REALIZED">
                <mat-icon class="positive-icon">check_circle</mat-icon>
              </ng-container>
              Edytuj</button>
          </div>
          <button class="bills-delete" mat-button color="warn" (click)="deleteInvoice(invoice.uuid, index)"><mat-icon>delete</mat-icon></button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
